var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4717 27.5293L21.9877 21.0453C23.649 19.164 24.6663 16.7013 24.6663 14C24.6663 8.11868 19.881 3.33334 13.9997 3.33334C8.11834 3.33334 3.33301 8.11868 3.33301 14C3.33301 19.8813 8.11834 24.6667 13.9997 24.6667C16.701 24.6667 19.1637 23.6493 21.045 21.988L27.529 28.472C27.6597 28.6027 27.8304 28.6667 28.001 28.6667C28.1717 28.6667 28.3424 28.6013 28.473 28.472C28.7317 28.212 28.7317 27.7907 28.4717 27.5293ZM13.9997 23.3347C8.85301 23.3347 4.66634 19.148 4.66634 14.0014C4.66634 8.85469 8.85301 4.66802 13.9997 4.66802C19.1463 4.66802 23.333 8.85469 23.333 14.0014C23.333 19.148 19.1463 23.3347 13.9997 23.3347Z",
    fill: "#10CAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlue);
export default __webpack_public_path__ + "static/media/search-blue.bc78cf0f0b41152dcb7964426879c603.svg";
export { ForwardRef as ReactComponent };